"use strict";
var navbar = document.querySelector('.site-header .navbar');
if (navbar) {
    var setNavbarHeight = function () {
        document.documentElement.style.setProperty('--navbar-h', "".concat(navbar.offsetHeight, "px"));
    };
    var onScroll = function () {
        document.body.classList.toggle('is-header-stuck', window.scrollY > 10);
    };
    setNavbarHeight();
    onScroll();
    window.addEventListener('resize', setNavbarHeight);
    window.addEventListener('scroll', onScroll, { passive: true });
}
